import RequestsWrapper from "~/tracking/requests";
import { Catch } from "~/tracking/utils/catch";
import { trackingFn } from "~/tracking/tracker";

export class Methods {
  private requests;

  constructor(apiKey: string) {
    this.requests = RequestsWrapper(apiKey);
  }

  @Catch
  public postEvent(params: Parameters<ReturnType<typeof trackingFn>>[0]) {
    const finalParams = {
      ...params,
      meta: {
        ...params.meta,
        event_time: new Date(),
      },
    };

    return trackingFn(this.requests)(finalParams);
  }
}

export const LocalLogicTracking = (apiKey: string) => new Methods(apiKey);
